<template>
    <div class="animated fadeIn">
        <table class="kgr-table kgr-table--striped kgr-table--block data-table table-groups printable">
            <thead>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Feld') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="row in createRows()"
                    class="kgr-table__row"
                >
                    <td class="kgr-table__cell">
                        <a
                            v-if="row.field.isEditable"
                            :href="urlForEdit(row.field)"
                            class="kgr-link"
                        >
                            {{ row.field.name }}
                        </a>
                        <div v-else>
                            {{ row.field.name }}
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import LocationImageUrlMixin from './LocationImageUrlMixin';

export default {
    name: 'KgrFieldsTable',
    mixins: [LocationImageUrlMixin],
    props: {
        fields: {
            type: Array,
            required: true,
        },
        filter: {
            type: String,
            required: false,
        }
    },
    methods: {
        createRows() {
            const rows = [];

            this.fields.forEach(field => {
                const row = {
                    'location': location,
                    'field': field,
                };
                if (this.rowMatchesFilter(row)) {
                    rows.push(row);
                }
            });
            return rows;
        },
        rowMatchesFilter(row) {
            if (null === this.filter || '' === this.filter) {
                return true;
            }

            const filter = this.filter.toLowerCase().trim();

            return row.field.name.toLowerCase().includes(filter);
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
